import React from "react";
import clsx from "clsx";
import { makeStyles, ThemeProvider as StylesThemeProvider } from "@mui/styles";
import UserRoleProfile from "../SystemAdminstration/userroleProfile";
import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BusinessUnit from "../Businessunits/businessUnits";
import Typography from "@mui/material/Typography";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { useHistory } from "react-router-dom";

import useMediaQuery from "@mui/material/useMediaQuery";
import { ThemeProvider } from "@mui/material/styles";
import WorkloadFileImport from "../WorkLoade_File_Import/workload-fileImport";
import BulkFormImport from "../WorkLoade_File_Import/bulkFormImport";
import AdminSystemLinks from "../SystemAdminstration/System_Links/systemLinks";
import ExportFunctionality from "../Export/export";
import ReportsProcess from "../Report/reports";
import ApprovalReviewProcess from "../Aproval_Review/approvalReview";
import { useEffect, useState, useRef } from "react";
import RejectionsFunction from "../Rejection/rejections";
import { CustomModal, fontFamily, menuItemStyle, useSharedValue } from "../Constants/constants";
import ExtractionApprovalReviewProcess from "../Extraction_View/extractionApproval";
import ExitToAppIcon from "@mui/icons-material/ExitToApp"; // Icon for logout
import Chat from "../CopilotWindow";
import InstaColors from "../Constants/constants";
import DispalyAndEditFile from "../WorkLoade_File_Import/display_and_edit_file";
import DisplayExtractionView from "../Extraction_View/displayExtractionView";
import Organisation from "../organisation/organisation";
import Notifications from "./notification_window";
import "../Main_Page/home.css";
import { CircularProgress } from "@mui/material";
import ProfileDropdown from "./userSetting";
import { BASE_URL, appVersion } from "../../App_Settings/app_settings";
import UsersIcon from "@mui/icons-material/Group";
import BusinessIcon from "@mui/icons-material/Business";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SettingsIcon from "@mui/icons-material/Settings";
import { createTheme } from "@mui/material/styles";
import BillingPage from "../Settings/Billing/BillingPage";
import UserSettings from "../AdminSettings/AdminSettings";
import ShepherdTour from "../../App_Tour/ShepherdTour";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import DashboardPage from "../Dashboard/dashboard";

let drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  popover: {
    width: "200px",
    height: "120px",
    alignItems: "center",
  },
  toolbar: {
    // paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: "white",
    minHeight: "0px",
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",

    justifyContent: "flex-end",
    //padding: '0 8px',
    ...theme.mixins.toolbar,
  },

  appBar: {
    boxShadow: "none",
    background: "transparent",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`, // Adjust based on your drawerWidth
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    color: "white",
  },

  drawerPaper: {
    backgroundImage: "linear-gradient(#2AA7E0,#0178B7)",
    boxShadow: "none",
    borderRight: "none",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    height: "100vh",
    overflowY: "scroll", // Enable vertical scrolling
    scrollbarWidth: "none", // Hide scrollbar for Firefox
    msOverflowStyle: "none", // Hide scrollbar for Internet Explorer and Edge
    transition: theme.transitions.create("width", {
      duration: theme.transitions.duration.enteringScreen,
    }),
    "&::-webkit-scrollbar": {
      display: "none", // Hide scrollbar for Chrome, Safari, and Edge
    },
  },

  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",

    overflow: "auto",
  },
  chatbotWindow: {
    width: "300px", // Adjusted to string with unit
    height: "100%",
    position: "fixed",

    right: "5px", // Adjusted to string with unit
    border: "1px solid #ccc",
    borderRadius: "10px", // Adjusted to string with unit
    overflow: "hidden",

    display: "flex",
    backgroundColor: "#F2F3F4",
    flexDirection: "column",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 480,
  },
  fixedHeight: {
    height: 480,
  },
  flexContainer: {
    display: "flex",
    flexDirection: "row",
  },
  firstDiv: {
    flex: 1, // Take up remaining space
  },
  secondDiv: {
    width: "320px", // Set fixed width of 250px
  },
}));

export default function Dashboard(props) {
  const [openPassword, setOpenPassword] = React.useState(false);
  const { notifications, handleNotificationList } = useSharedValue();
  const { handleCheckTourCompleted, isTourCompleted, handleTourGuide } = useSharedValue();
  const { selectedRows, handleSelectedRows } = useSharedValue();
  const [selectedMenu, setSelectedMenu] = React.useState(false);
  const settingsRef = useRef(null);
  const helpRef = useRef(null);

  const [previousSelectedMenu, setpreviousSelectedMenu] = React.useState(false);
  const [selectAdminItem, setSelecteAdminItem] = React.useState(null);
  const { isMenuOpen, updateDrawerMenu } = useSharedValue();
  const { isDirectNavigation, updateDirectNavigation } = useSharedValue();

  // Step 1: Add a state variable for chat window visibility
  const { isChatWindowVisible, updateDisplayChatWindowValue } = useSharedValue();
  const { isNotificationWindowVisible, updateNotificationWindowValue } = useSharedValue();
  const history = useHistory();
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("Checker");
  const [userEmail, setUserEmail] = useState("");
  const {
    defaultBusinessunit,
    getBusinessUnits,
    handleSetValueDefaultBusinessunit,
    businessUnitsList,
    defaultOrganization,
    handleSetValueDefaultOrganization,
    handleSetValueDefaultUser,
    defaultUser,
  } = useSharedValue();
  const [expand, setExpand] = React.useState(false);
  const [editingData, setEditingData] = React.useState(null);
  const { handleExtractLimit, handleUserTraiLimit, extractLimit } = useSharedValue();
  const [openPopup, setOpenPopup] = useState(false);

  const [openVideoPopup, setOpenVideoPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isSettingsHovered, setIsSettingsHovered] = useState(false);
  const [isHelpHovered, setIsHelpHovered] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const { isProcessing, handleProcessingDialogue, isPackProcessStarted } = useSharedValue();

  const menuItems = [
    { id: "users", icon: UsersIcon, label: "Users Profile" },
    { id: "business", icon: BusinessIcon, label: "Clients" },
    { id: "userSettings", icon: SettingsIcon, label: "Admin Settings" },
    { id: "organization", icon: AccountTreeIcon, label: "Organisation" },
    // { id: "billing", icon: LinkIcon, label: "Billing" },
    // { id: 'system', icon: LinkIcon, label: 'System Links(APIs)' }
  ];

  const [systemAdminAnchorEl, setSystemAdminAnchorEl] = useState(null);
  const menuTitles = {
    dashboard: "Dashboard",
    workloadFileImport: "File Import",
    bulkFormImport: "Bulk Form Import",
    home: "File Import",
    displayAndEditFile: "Upload Review",
    extractionReview: "Extraction Review",
    approval: "Approval Process",
    rejections: "Rejections",
    export: "Export",
    displayExtractionView: "Extraction View",
    reports: "Reports",
    userRoleProfile: "Settings | Users Profile",
    businessUnit: "Settings | Clients",
    systemLink: "Settings | System Links",
    organisation: "Settings | Organization",
    billing: "Settings | Billing",
    userSettings: "Settings | Admin Settings",
  };
  const handleSystemAdminClick = (event) => {
    // Check both role access and extraction limit
    if (hasAccess("settings") && extractLimit === null) {
      setSystemAdminAnchorEl(event.currentTarget);
    } else {
      showPermissionAlert();
    }

    // setSelectedMenu('systemadmin')
    // setSelecteAdminItem('')
  };

  useEffect(() => {
    handleCheckTourCompleted();
  }, [isTourCompleted]);

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  document.addEventListener("contextmenu", (event) => event.preventDefault());
  // Disable F12 key and Ctrl+Shift+I combo
  // document.addEventListener('keydown', event => {
  //   if (event.keyCode === 123 || (event.ctrlKey && event.shiftKey && event.keyCode === 73)) {
  //     event.preventDefault();
  //   }
  // });
  useEffect(() => {
    getBusinessUnits();
    // uploadPreLoadedFiles();

    // getDataRows();
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      getUser(userData.userId, userData.organizationId);
      createBusinessUnit(userData);
      setUserName(userData.firstName + " " + userData.lastName);
      setUserEmail(userData.userName);

      // Make sure 'email' property exists in your data.
    }
  }, []);

  const LOCAL_STORAGE_KEY = "notifications_list";

  // Load notifications from local storage when the component mounts
  useEffect(() => {
    handleUserTraiLimit();
    const storedNotifications = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (storedNotifications) {
      handleNotificationList(JSON.parse(storedNotifications));
    }
  }, []);

  // Save notifications to local storage whenever the notifications list changes
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(notifications));
  }, [notifications]);

  // Load notifications from local storage when the component mounts
  useEffect(() => {
    const storedSelectedFiles = localStorage.getItem("SelectedFilesList");
    if (storedSelectedFiles) {
      handleSelectedRows(JSON.parse(storedSelectedFiles));
    }
  }, []);

  // Save notifications to local storage whenever the notifications list changes
  useEffect(() => {
    localStorage.setItem("SelectedFilesList", JSON.stringify(selectedRows));
  }, [selectedRows]);

  const getUser = async (userId, organizationId) => {
    // Fetch users based on organization ID
    const response = await fetch(`${BASE_URL}/users/${userId}/${organizationId}`, {
      headers: {
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
    });
    if (response.ok) {
      const user = await response.json();

      if (user) {
        if (user.isSuperAdmin) {
          setIsSuperAdmin(user.isSuperAdmin);
          if (user.isSuperAdmin) setUserRole("Admin");
        }
        if (user.userRoles && user.userRoles.length > 0) {
          // Define the role priority order (higher roles come first)
          const rolePriority = ["Admin", "Checker", "Maker"];

          // Sort the roles the user has based on priority
          const sortedRoles = user.userRoles
            .map((role) => role.name) // Extract role names
            .sort((a, b) => rolePriority.indexOf(a) - rolePriority.indexOf(b)); // Sort based on priority order

          setUserRole(sortedRoles[0]);
          console.log(sortedRoles[0]);
          console.log(sortedRoles[0]);
        }
      } else {
        console.warn("User ID not found in the fetched data.");
      }
    } else {
      console.error("Failed to fetch users:", response.statusText);
    }
  };
  const createBusinessUnit = (userData) => {
    fetch(`${BASE_URL}/BusinessUnits/${userData.organizationId}`, {
      headers: {
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Filter the data based on the search value
        let filteredData = data;

        // Check if there are no business units
        if (filteredData.length === 0) {
          const demoBusinessUnit = {
            name: "Demo",
            createdBy: userData.userName,
            isDefault: true, // or false based on your logic
            delete: false,
            createdDate: new Date().toISOString(),
            organizationId: userData.organizationId,
          };

          // Add "Demo Business Unit" to the backend
          fetch(`${BASE_URL}/BusinessUnits`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
            },
            body: JSON.stringify(demoBusinessUnit),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
            })
            .then(() => {
              // Update the rows state with the demo business unit
            })
            .catch((error) => {
              console.error("Error adding Demo Client:", error);
            });
        } else {
          // Update rows if data is already present
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  // Step 2: Toggle chat window visibility
  const toggleChatWindow = () => {
    updateDisplayChatWindowValue(!isChatWindowVisible);
  };
  const handleNotifactionWindow = () => {
    updateNotificationWindowValue(!isNotificationWindowVisible);
  };
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = '';
  //     alert("Do you really want to close?");
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);
  const handleDrawerClose = (value) => {
    updateDrawerMenu(value);
    const userDataJSON = localStorage.getItem("token");

    if (value === false) {
      if (userDataJSON) {
        const userData = JSON.parse(userDataJSON);

        const firstLetterOfFirstName = userData.firstName.charAt(0);
        const firstLetterOfLastName = userData.lastName.charAt(0);
        setUserName(firstLetterOfFirstName + firstLetterOfLastName);

        // Make sure 'email' property exists in your data.
      }

      drawerWidth = 50;
    } else {
      if (userDataJSON) {
        const userData = JSON.parse(userDataJSON);

        const firstLetterOfFirstName = userData.firstName;
        const firstLetterOfLastName = userData.lastName;
        setUserName(firstLetterOfFirstName + firstLetterOfLastName);

        // Make sure 'email' property exists in your data.
      }

      drawerWidth = 240;
    }
    setOpen(value);
  };

  useEffect(() => {
    if (window.performance) {
      if (performance.navigation.type == 1) {
        // Perform action only on page reload or direct navigation
      } else {
        if (isDirectNavigation === false) handleLogout();
      }
    }
  }, []);

  const handleLogout = () => {
    setSelecteAdminItem("");
    localStorage.removeItem("token");
    localStorage.removeItem("CopilotToken");
    history.replace("/login");
  };
  const navigate = (value) => {
    history.push({
      pathname: value,
    });
  };
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  // replaced createTheme with this createMuiTheme.
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          type: prefersDarkMode ? "dark" : "light",
        },
      }),
    [prefersDarkMode]
  );

  const handleChange = (event) => {
    handleSetValueDefaultBusinessunit(event.target.value); // Update selected business unit
  };

  // Empty dependency array to run this effect only once on component mount.

  const routeComponents = {
    "/home": <WorkloadFileImport />,
    "/dashboard": <DashboardPage />,
    "/workloadFileImport": <WorkloadFileImport />,
    "/bulkFormImport": <BulkFormImport />,
    "/displayAndEditFile": <DispalyAndEditFile />,
    "/extractionReview": <ExtractionApprovalReviewProcess />,
    "/displayExtractionView": <DisplayExtractionView />,
    "/approval": <ApprovalReviewProcess />,
    "/export": <ExportFunctionality />,
    "/reports": <ReportsProcess />,
    "/approvalReviewProcess": <ApprovalReviewProcess />,
    "/userRoleProfile": <UserRoleProfile />,
    "/businessUnit": <BusinessUnit />,
    "/systemLink": <AdminSystemLinks />,
    "/organisation": <Organisation />,
    "/billing": <BillingPage />,
    "/userSettings": <UserSettings />,
    "/rejections": <RejectionsFunction />,
    "/extractionApproval": <ExtractionApprovalReviewProcess />,

    // Add more routes and components as needed
  };

  // Get the component to render based on the current pathname
  const currentPath = history.location.pathname;
  const componentToRender = routeComponents[currentPath] || <WorkloadFileImport />;

  useEffect(() => {
    setSelectedMenu(currentPath.substring(1));
  }, [currentPath]);

  useEffect(() => {
    if (selectedMenu != "systemadmin" && selectedMenu != "undefined" && selectedMenu != null) {
      setpreviousSelectedMenu(selectedMenu);
    }
  }, [selectedMenu]);

  const handleSupportClick = () => {
    setSelecteAdminItem("");
    setSelectedMenu("support");
    const email = "support@complyexchange.com";
    const subject = "Support Request";
    const body = "Please describe your support request here.";
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(mailtoUrl, "_blank");
  };

  // Access rules for each role
  const accessRules = {
    Maker: {
      accessibleTabs: [
        "rejections",
        "export",
        "reports",
        "extractionReview",
        "workloadFileImport",
        "bulkFormImport",
        "support",
        "dashboard",
      ],
      alertMessage: "You do not have permission to access this feature in your trial version.",
    },
    Checker: {
      accessibleTabs: [
        "approval",
        "rejections",
        "export",
        "reports",
        "support",
        "extractionReview",
        "workloadFileImport",
        "bulkFormImport",
        "dashboard",
      ],
      alertMessage: "You do not have permission to access this feature in your trial version.",
    },
    Admin: {
      accessibleTabs: [
        "workloadFileImport",
        "bulkFormImport",
        "extractionReview",
        "approval",
        "rejections",
        "export",
        "reports",
        "settings",
        "support",
        "dashboard",
      ],
      alertMessage: "You do not have permission to access this feature in your trial version.",
    },
  };
  // Check if the user has access to a specific tab
  const hasAccess = (tab) => accessRules[userRole]?.accessibleTabs.includes(tab);

  // Show alert message
  const showPermissionAlert = () => {
    // alert(accessRules[userRole]?.alertMessage || "Access denied.");
    setPopupMessage(accessRules[userRole]?.alertMessage || "Access denied.");
    setOpenPopup(true);
  };

  const [organizations, setOrganizations] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  // Add this useEffect to fetch organizations and users
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isSuperAdmin) {
          const orgResponse = await fetch(
            `${BASE_URL}/Organization/${getUserIdFromLocalStorage().userId}/${
              getUserIdFromLocalStorage().organizationId
            }`,
            {
              headers: {
                Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
              },
            }
          );
          if (orgResponse.ok) {
            const orgData = await orgResponse.json();

            // Filter out invalid entries and remove duplicates by name
            const uniqueNameMap = new Map();

            // Keep only the first occurrence of each name
            orgData
              .filter((org) => org && org.id && org.name)
              .forEach((org) => {
                if (!uniqueNameMap.has(org.name)) {
                  uniqueNameMap.set(org.name, org);
                }
              });

            // Convert back to array
            const uniqueOrgs = Array.from(uniqueNameMap.values());

            setOrganizations(uniqueOrgs.reverse());
          }
        } else if (userRole === "Admin") {
          // Fetch users for admin
          const userDataJSON = localStorage.getItem("token");
          if (userDataJSON) {
            const userData = JSON.parse(userDataJSON);
            const usersResponse = await fetch(
              `${BASE_URL}/users/getAllUsers/${userData.organizationId}`,
              {
                headers: {
                  Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                },
              }
            );
            if (usersResponse.ok) {
              const usersData = await usersResponse.json();
              setUsers(usersData.filter((user) => user.isDeleted === false));
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [isSuperAdmin, userRole]);

  return (
    <ThemeProvider theme={theme}>
      <StylesThemeProvider theme={theme}>
        <div className={classes.root}>
          {isTourCompleted == false && <ShepherdTour />}
          {/* <ShepherdTour /> */}
          <Drawer
            variant="permanent"
            style={{
              position: "relative",
              whiteSpace: "nowrap",
              width: drawerWidth,
              border: "none",
              transition: theme.transitions.create("width", {
                duration: theme.transitions.duration.enteringScreen,
              }),
            }}
            classes={{
              paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            open={open}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontFamily: fontFamily,
                marginTop: "20px",
                marginBottom: 30,
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                <div
                  title={open === true ? "Hide Menu" : "Open Menu"}
                  style={{ marginRight: "auto" }}
                />
                {open === true ? (
                  <img
                    title={open === true ? "Hide Menu" : "Open Menu"}
                    onClick={() => {
                      handleDrawerClose(!open);
                    }}
                    src="./ShrinkMenuIcon.png"
                    alt="Menu"
                    height="25"
                    width="25"
                    style={{ marginRight: 10 }}
                  ></img>
                ) : (
                  <img
                    title={open === true ? "Hide Menu" : "Open Menu"}
                    onClick={() => {
                      handleDrawerClose(!open);
                    }}
                    src="./GrowMenuIcon.png"
                    alt="Menu"
                    height="25"
                    width="25"
                    style={{ marginRight: 6 }}
                  ></img>
                )}
              </div>

              <img src="./CE.png" alt="Person" height="50" width="50"></img>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  overflow: "hidden",
                }}
              >
                <span
                  style={{
                    color: "white",
                    marginTop: "10px",
                    fontFamily: fontFamily,
                    fontWeight: 600,
                    letterSpacing: 0.8,
                    visibility: open ? "visible" : "hidden",
                  }}
                >
                  Comply Extractor
                </span>
              </div>
            </div>
            <ListItem
              button
              component="div"
              data-testid="file-import"
              to={hasAccess("dashboard") ? "/dashboard" : undefined}
              onClick={() => {
                if (hasAccess("dashboard")) {
                  setSelectedMenu("dashboard");
                  setSelecteAdminItem("");
                  navigate("/dashboard");
                } else {
                  showPermissionAlert();
                }
              }}
              title=""
              style={{
                backgroundColor: selectedMenu === "dashboard" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={selectedMenu === "dashboard" ? "./Dashboard(B).png" : "./Dashboard(W).png"}
                  alt="Dashboard"
                  title="Dashboard"
                  height="20"
                  width="20"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    color: "white",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "dashboard")}>
                    Dashboard
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              component="div"
              data-testid="file-import"
              to={hasAccess("workloadFileImport") ? "/workloadFileImport" : undefined}
              onClick={() => {
                if (hasAccess("workloadFileImport")) {
                  setSelectedMenu("workloadFileImport");
                  setSelecteAdminItem("");
                  navigate("/workloadFileImport");
                } else {
                  showPermissionAlert();
                }
              }}
              title=""
              style={{
                backgroundColor: selectedMenu === "workloadFileImport" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={
                    selectedMenu === "workloadFileImport" ? "./Import(B).png" : "./Import(W).png"
                  }
                  alt="Workload File Import"
                  title="File Import"
                  height="20"
                  width="20"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    color: "white",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    variant="body2"
                    style={menuItemStyle(selectedMenu, "workloadFileImport")}
                  >
                    File Import
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              component="div"
              data-testid="bulk-form-import"
              to={hasAccess("bulkFormImport") ? "/bulkFormImport" : undefined}
              onClick={() => {
                if (hasAccess("bulkFormImport")) {
                  setSelectedMenu("bulkFormImport");
                  setSelecteAdminItem("");
                  navigate("/bulkFormImport");
                } else {
                  showPermissionAlert();
                }
              }}
              title=""
              style={{
                backgroundColor: selectedMenu === "bulkFormImport" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={selectedMenu === "bulkFormImport" ? "./Bulk(B).png" : "./Bulk(W).png"}
                  alt="Bulk Form Import"
                  title="Bulk Form Import"
                  height="20"
                  width="20"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    color: "white",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "bulkFormImport")}>
                    Bulk Form Import
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              component="div"
              data-testid="extraction-review"
              to={hasAccess("extractionReview") ? "/extractionReview" : undefined}
              onClick={() => {
                if (hasAccess("extractionReview")) {
                  setSelectedMenu("extractionReview");
                  setSelecteAdminItem("");
                  navigate("/extractionReview");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "extractionReview" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={selectedMenu === "extractionReview" ? "./Review(B).png" : "./Review(W).png"}
                  alt="Extraction Review"
                  title="Extraction Review"
                  height="20"
                  width="20"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    variant="body2"
                    style={menuItemStyle(selectedMenu, "extractionReview")}
                  >
                    Extraction Review
                  </Typography>
                }
              />
            </ListItem>
            {hasAccess("approval") && (
              <ListItem
                button
                component="div"
                data-testid="approval-review"
                to="/approval"
                onClick={() => {
                  setSelectedMenu("approval");
                  setSelecteAdminItem("");
                  navigate("/approval");
                }}
                style={{
                  backgroundColor: selectedMenu === "approval" ? "white" : "transparent",
                  marginBottom: 10,
                }}
              >
                <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                  <img
                    src={selectedMenu === "approval" ? "./Approve(B).png" : "./Approve(W).png"}
                    alt="Approval"
                    height="20"
                    title="Approval Process"
                    width="20"
                    style={{
                      padding: 0,
                      margin: 0,
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography variant="body2" style={menuItemStyle(selectedMenu, "approval")}>
                      Approval Process
                    </Typography>
                  }
                />
              </ListItem>
            )}
            <ListItem
              button
              component="div"
              data-testid="reject"
              to={hasAccess("rejections") ? "/rejections" : undefined}
              onClick={() => {
                if (hasAccess("rejections")) {
                  setSelectedMenu("rejections");
                  setSelecteAdminItem("");
                  navigate("/rejections");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "rejections" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={selectedMenu === "rejections" ? "./Reject(B).png" : "./Reject(W).png"}
                  alt="Rejections"
                  height="20"
                  title="Rejections"
                  width="20"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "rejections")}>
                    Rejections
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              component="div"
              data-testid="export"
              to={hasAccess("export") ? "/export" : undefined}
              onClick={() => {
                if (hasAccess("export")) {
                  setSelectedMenu("export");
                  setSelecteAdminItem("");
                  navigate("/export");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "export" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={selectedMenu === "export" ? "./Export(B).png" : "./Export(W).png"}
                  alt="Export"
                  height="20"
                  width="20"
                  title="Export"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "export")}>
                    Export
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              data-testid="report"
              button
              component="div"
              to="/reports"
              onClick={() => {
                if (hasAccess("reports")) {
                  setSelectedMenu("reports");
                  setSelecteAdminItem("");
                  navigate("/reports");
                } else {
                  showPermissionAlert();
                }
              }}
              style={{
                backgroundColor: selectedMenu === "reports" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={selectedMenu === "reports" ? "./Report(B).png" : "./Report(W).png"}
                  alt="Reports"
                  height="20"
                  width="20"
                  title="Reports"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "reports")}>
                    Reports
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              data-testid="settings"
              ref={settingsRef}
              onMouseEnter={() => {
                setIsSettingsHovered(true);
                // Auto-scroll to ensure Settings menu is visible
                if (settingsRef.current) {
                  settingsRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  });
                }
              }}
              onMouseLeave={() => {
                setIsSettingsHovered(false);
              }}
              onClick={handleSystemAdminClick}
              style={{
                backgroundColor:
                  selectedMenu === "systemadmin" ||
                  selectedMenu === "userRoleProfile" ||
                  selectedMenu === "businessUnit" ||
                  selectedMenu === "systemLink" ||
                  selectedMenu === "userSettings" ||
                  selectedMenu === "organisation"
                    ? "white"
                    : "transparent",
                marginBottom: 10,
                cursor: "pointer",
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <img
                  src={
                    selectedMenu === "systemadmin" ||
                    selectedMenu === "userRoleProfile" ||
                    selectedMenu === "businessUnit" ||
                    selectedMenu === "systemLink" ||
                    selectedMenu === "userSettings" ||
                    selectedMenu === "organisation"
                      ? "./Settings(B).png"
                      : "./Settings(W).png"
                  }
                  alt="System Admin"
                  title="Settings"
                  height="20"
                  width="20"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    variant="body2"
                    style={{
                      color:
                        selectedMenu === "systemadmin" ||
                        selectedMenu === "userRoleProfile" ||
                        selectedMenu === "businessUnit" ||
                        selectedMenu === "systemLink" ||
                        selectedMenu === "organisation" ||
                        selectedMenu === "userSettings"
                          ? "#2aa7e0"
                          : "white",
                      fontSize: 14,
                      fontFamily: fontFamily,
                      fontWeight: 300,
                    }}
                  >
                    Settings
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              data-testid="support"
              // onClick={() => { handleHelpClick() }}
              onMouseEnter={() => setIsHelpHovered(true)}
              onMouseLeave={() => setIsHelpHovered(false)}
              ref={helpRef}
              style={{
                backgroundColor: selectedMenu === "help" ? "white" : "transparent",
                marginBottom: 10,
              }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <HelpOutlineIcon
                  title="Help"
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    color: "white",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "help")}>
                    Help
                  </Typography>
                }
              />
            </ListItem>

            <ListItem
              button
              title="Logout"
              onClick={handleLogout}
              style={{ color: "white", marginTop: "auto", marginBottom: 20 }}
            >
              <ListItemIcon style={{ minWidth: "50px", marginLeft: !open ? 10 : 30 }}>
                <ExitToAppIcon
                  style={{
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    color: "white",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2" style={menuItemStyle(selectedMenu, "")}>
                    Logout
                  </Typography>
                }
              />
            </ListItem>

            {/* Version label at bottom center */}
            <div
              style={{
                display: "flex",

                // justifyContent: "center",
                // alignItems: "center",
                marginBottom: 10,
                marginLeft: open === true ? 49 : 14,
                color: "white",
                fontSize: "14px",
                opacity: 0.8,
                fontFamily: fontFamily,
              }}
            >
              {open ? `version: ${appVersion}` : `v: ${appVersion}`}
            </div>
          </Drawer>
          <main
            className={classes.content}
            style={{
              backgroundColor: "#E8EAEC",
              marginLeft: open === false ? 20 : 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                height: "44px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginLeft: 20,
                marginTop: 20,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", height: "36px" }}>
                <span
                  style={{
                    color: InstaColors.primary,
                    fontFamily: "Poppins, sans-serif", // Add this line
                    fontWeight: 300,
                    fontSize: 28,
                  }}
                >
                  {" "}
                  {menuTitles[selectedMenu] ? (
                    <>{menuTitles[selectedMenu]}</>
                  ) : selectedMenu === "systemadmin" ? (
                    menuTitles[previousSelectedMenu]
                  ) : (
                    selectedMenu
                  )}
                </span>
              </div>
              {/* <Loader /> */}
              <div style={{ display: "flex", marginLeft: "auto", marginRight: 10 }}>
                {" "}
                {isPackProcessStarted === true && isProcessing === false && (
                  //   < DataSaverOnIcon onClick={() => {
                  //   handleProcessingDialogue(true);
                  // }} style={{ color: InstaColors.primary, fontSize: 30 }} />
                  <div
                    className="processing-button-container"
                    style={{
                      padding: "12px 20px",
                      borderRadius: "8px",
                      height: 35,
                      backgroundColor: "white",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "fit-content",
                      cursor: isPackProcessStarted && !isProcessing ? "pointer" : "default",
                    }}
                    onClick={() => {
                      if (isPackProcessStarted && !isProcessing) {
                        handleProcessingDialogue(true);
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <CircularProgress size={20} style={{ color: InstaColors.primary }} />

                      <span
                        style={{
                          color: "#555",
                          fontFamily: "sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Processing
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {/* Add organization/user dropdowns with search */}
              {(isSuperAdmin || userRole === "Admin") && (
                <div style={{ marginLeft: 20, width: isSuperAdmin ? 192 : 180 }}>
                  {isSuperAdmin && (
                    <Autocomplete
                      options={organizations}
                      getOptionLabel={(option) => option.name || ""}
                      value={defaultOrganization}
                      onChange={(event, newValue) => {
                        handleSetValueDefaultOrganization(newValue);
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      renderInput={(params) => {
                        const { InputProps, ...rest } = params;
                        return (
                          <TextField
                            {...rest}
                            variant="outlined"
                            placeholder="Search Organization"
                            size="small"
                            InputProps={{
                              ...InputProps,
                              style: {
                                ...InputProps.style,
                                padding: "0",
                                height: "36px",
                                fontSize: "14px",
                                backgroundColor: InstaColors.button_background,
                                borderRadius: "10px",
                                border: "none",
                              },
                              inputProps: {
                                ...params.inputProps,
                                style: {
                                  ...params.inputProps?.style,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  paddingRight: "56px",
                                },
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  border: "none",
                                },
                                "&:hover fieldset": {
                                  border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                  border: "none",
                                },
                              },
                            }}
                          />
                        );
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: "1.2em",
                            maxHeight: "2.7em",
                            padding: "8px 16px",
                          }}
                        >
                          {option.name}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value?.id}
                      noOptionsText="No organizations found"
                      fullWidth
                    />
                  )}

                  {userRole === "Admin" && !isSuperAdmin && (
                    <Autocomplete
                      options={users}
                      getOptionLabel={(option) => `${option.email}` || ""}
                      value={defaultUser}
                      onChange={(event, newValue) => {
                        handleSetValueDefaultUser(newValue);
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchTerm = inputValue.toLowerCase().trim();
                        return options.filter((option) =>
                          option.email.toLowerCase().includes(searchTerm)
                        );
                      }}
                      renderInput={(params) => {
                        const { InputProps, ...rest } = params;
                        return (
                          <TextField
                            {...rest}
                            InputProps={{
                              ...InputProps,
                              style: {
                                ...InputProps.style,
                                padding: "0",
                                height: "36px",
                                fontSize: "14px",
                                backgroundColor: InstaColors.button_background,
                                borderRadius: "10px",
                                border: "none",
                              },
                              inputProps: {
                                ...params.inputProps,
                                style: {
                                  ...params.inputProps?.style,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  paddingRight: "56px",
                                },
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  border: "none",
                                },
                                "&:hover fieldset": {
                                  border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                  border: "none",
                                },
                              },
                            }}
                            variant="outlined"
                            placeholder="Search User"
                            size="small"
                          />
                        );
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: "1.2em",
                            maxHeight: "2.7em",
                            padding: "8px 16px",
                          }}
                        >
                          {option.email}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value?.id}
                      noOptionsText="No users found"
                      fullWidth
                    />
                  )}
                </div>
              )}

              {/* Update business unit dropdown to use Autocomplete */}
              <div style={{ marginLeft: 15, marginRight: 15, width: 180 }} data-testid="clients">
                <Autocomplete
                  options={businessUnitsList}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    businessUnitsList.find((unit) => unit.name === defaultBusinessunit) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({ target: { value: newValue?.name || "" } });
                  }}
                  renderInput={(params) => {
                    // Modify the input props to handle text overflow
                    const { InputProps, ...rest } = params;
                    return (
                      <TextField
                        {...rest}
                        variant="outlined"
                        placeholder="Search Client"
                        size="small"
                        InputProps={{
                          ...InputProps,
                          style: {
                            ...InputProps.style,
                            padding: "0",
                            height: "36px",
                            fontSize: "14px",
                            backgroundColor: InstaColors.button_background,
                            borderRadius: "10px",
                            border: "none",
                          },
                          // Add styles to the input element itself
                          inputProps: {
                            ...params.inputProps,
                            style: {
                              ...params.inputProps?.style,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              paddingRight: "56px", // Make room for the close and dropdown icons
                            },
                          },
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none",
                            },
                            "&:hover fieldset": {
                              border: "none",
                            },
                            "&.Mui-focused fieldset": {
                              border: "none",
                            },
                          },
                        }}
                      />
                    );
                  }}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: "1.2em",
                        maxHeight: "2.7em",
                        padding: "8px 16px",
                      }}
                    >
                      {option.name}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  noOptionsText="No clients found"
                  fullWidth
                />
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div data-testid="copilot">
                  {" "}
                  <img
                    src="./copilot.png"
                    onClick={toggleChatWindow}
                    height="44px"
                    width="44px"
                    alt="Copilot"
                    style={{ background: InstaColors.background }}
                  ></img>
                </div>
                {/* <div data-testid="helpVideo">   <img onClick={() => {
                window.open('https://player.vimeo.com/video/1048553046', '_blank');
              }} style={{ marginLeft: 15 }} src='./VideoIcon.png' alt="Help Video" height="40" width="40" title='Help Video' /></div> */}

                <div data-testid="notifications" className="notification-icon-container">
                  <img
                    onClick={handleNotifactionWindow}
                    src="./notification.png"
                    alt="Notification"
                    height="70"
                    width="70"
                    style={{ marginTop: 6 }}
                  />
                  {notifications?.length !== 0 && (
                    <span
                      onClick={handleNotifactionWindow}
                      className="notification-badge"
                      style={{
                        padding:
                          notifications?.length >= 1000
                            ? "6px 9px"
                            : notifications?.length >= 100
                              ? "5px 8px"
                              : notifications?.length >= 10
                                ? "3px 6px"
                                : "1px 6px",
                        marginTop: 6,
                      }}
                    >
                      {notifications.length}
                    </span>
                  )}
                </div>
                <ProfileDropdown />
              </div>
            </div>
            {componentToRender}
            {isChatWindowVisible && <Chat />}
            {isNotificationWindowVisible && <Notifications />}
          </main>

          <CustomModal
            open={openPopup}
            onClose={() => setOpenPopup(false)}
            title="Access Denied"
            description={popupMessage}
          />
          {isHelpHovered && (
            <div
              style={{
                position: "fixed",
                left: open ? "240px" : "72px",
                top: helpRef.current?.getBoundingClientRect().top || 0,
                backgroundImage: "linear-gradient(#2AA7E0,#0178B7)",
                width: "188px",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                zIndex: 1004,
                fontFamily: fontFamily,
                borderRadius: "4px",
                overflow: "hidden",
              }}
              onMouseEnter={() => setIsHelpHovered(true)}
              onMouseLeave={() => setIsHelpHovered(false)}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "16px 10px",
                  fontFamily: fontFamily,
                  cursor: "pointer",
                  color: "white",
                  backgroundColor: "transparent",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#2F539B";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
                onClick={() => {
                  handleTourGuide();
                  setIsHelpHovered(false);
                }}
              >
                <HelpOutlineIcon style={{ width: 22, height: 22, marginRight: 20 }} />
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 300,
                    fontFamily: fontFamily,
                  }}
                >
                  Help Guide
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "16px 10px",
                  fontFamily: fontFamily,
                  cursor: "pointer",
                  color: "white",
                  backgroundColor: "transparent",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#2F539B";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
                onClick={() => {
                  handleSupportClick();
                  setIsHelpHovered(false);
                }}
              >
                {" "}
                <img
                  src={selectedMenu === "help" ? "./Support(B).png" : "./Support(W).png"}
                  alt="Help"
                  height="20"
                  title="Help"
                  width="20"
                  style={{ width: 22, height: 22, marginRight: 20 }}
                />
                {/* <SupportAgentIcon style={{ width: 22, height: 22, marginRight: 20 }} /> */}
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 300,
                    fontFamily: fontFamily,
                  }}
                >
                  Contact Us
                </span>
              </div>
            </div>
          )}

          {isSettingsHovered && (
            <div
              style={{
                position: "fixed", // Change to fixed positioning
                left: open ? "240px" : "72px", // Adjust based on drawer width
                top: settingsRef.current?.getBoundingClientRect().top || 0, // Align with settings item
                backgroundImage: "linear-gradient(#2AA7E0,#0178B7)",
                width: "188px",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                zIndex: 1004,
                fontFamily: fontFamily,
                borderRadius: "4px",
                overflow: "hidden",
              }}
              onMouseEnter={() => setIsSettingsHovered(true)}
              onMouseLeave={() => setIsSettingsHovered(false)}
            >
              {menuItems
                .filter((subItem) => isSuperAdmin || subItem.id !== "organization") // Only include 'organization' if isSuperAdmin is true
                .filter((subItem) => !isSuperAdmin || subItem.id !== "userSettings") // Hide 'Admin Settings' for super admins
                .map((subItem) => (
                  <div
                    key={subItem.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "16px 10px",
                      fontFamily: fontFamily,
                      cursor: "pointer",
                      color: selectAdminItem === subItem.label ? "#2aa7e0" : "white",
                      backgroundColor: selectAdminItem === subItem.label ? "white" : "#2aa7e0",
                      transition: "background-color 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      if (selectAdminItem !== subItem.label) {
                        e.currentTarget.style.backgroundColor = "#2F539B";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectAdminItem !== subItem.label) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                    onClick={() => {
                      if (subItem.id === "users") {
                        if (hasAccess("settings") && extractLimit === null) {
                          navigate("/userRoleProfile");
                          setSelectedMenu("userRoleProfile");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                      } else if (subItem.id === "business") {
                        if (hasAccess("settings") && extractLimit === null) {
                          navigate("/businessUnit");
                          setSelectedMenu("businessUnit");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                      } else if (subItem.id === "userSettings") {
                        // Admin Settings - accessible to admins and super admins only
                        if ((userRole === "Admin" || isSuperAdmin) && extractLimit === null) {
                          navigate("/userSettings");
                          setSelectedMenu("userSettings");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                      } else if (subItem.id === "organization") {
                        if (hasAccess("settings") && extractLimit === null) {
                          navigate("/organisation");
                          setSelectedMenu("organisation");
                          setSelecteAdminItem(subItem.label);
                        } else {
                          showPermissionAlert();
                        }
                        // }  else if (subItem.id === "billing") {
                        //   if (hasAccess("settings") && extractLimit === null) {
                        //     navigate("/billing");
                        //     setSelectedMenu("billing");
                        //     setSelecteAdminItem(subItem.label);
                        //   } else {
                        //     showPermissionAlert();
                        //   }
                      }
                      setIsSettingsHovered(false);
                    }}
                  >
                    <subItem.icon style={{ width: 22, height: 22, marginRight: 20 }} />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 300,
                        fontFamily: fontFamily,
                      }}
                    >
                      {subItem.label}
                    </span>
                  </div>
                ))}
            </div>
          )}
        </div>
      </StylesThemeProvider>
    </ThemeProvider>
  );
}
